import { useState, useEffect } from 'react';

import styles from './RadioButton.module.scss';

export type RadioButtonProps = {
  id: string;
  name?: string;
  label?: string;
  handleClick?: () => void;
  customClassName?: string;
  isChecked?: boolean;
  disabled?: boolean
}
const RadioButton = (props: RadioButtonProps): React.JSX.Element => {
  const { id, name, label, handleClick, isChecked = false, customClassName, disabled = false } = props;

  const [customCheck, setCustomCheck] = useState(isChecked);

  useEffect(() => {
    setCustomCheck(isChecked);
  }, [isChecked]);

  const customClick = () => {
    if (!disabled && !customCheck) {
      setCustomCheck(true);
      handleClick?.();
    }
  };

  const labelClassName = [disabled && styles.disabled].filter(Boolean).join(' ');

  return (
    <div className={`${styles.container}${customClassName ? ' ' + customClassName : ''}`} data-test-id="radio-button" data-rbf="radio-button">
      <input
        id={id}
        data-rbf={id}
        type="radio"
        name={name}
        checked={customCheck}
        onChange={customClick}
        disabled={disabled}
      />
      <span onClick={customClick} data-test-id="radio-button-span" />
      {label && (
        <label className={labelClassName} htmlFor={id} data-test-id="radio-button-label">{label}</label>
      )}
    </div>
  );
};

export default RadioButton;
